import React, { useState } from "react";

import ListContentWrapper from "../../../common/management/ListContentWrapper";
import ListWrapper from "../../../common/management/ListWrapper";
import TermList from "../../management/taxonomy/TermList";
import AddTerm from "../../management/taxonomy/AddTerm";

import { useAppSelector } from "../../../redux/hooks";
import { getAuthToken } from "../../../redux/reducers/auth";

import { genDisplayCount } from "../../../utils/GeneralUtils";
import { TermType, useGetTerm, useUpdateTerm } from "../../../utils/useTerm";

type Props = {
  currentPage: number;
  perView: number;
};

export const CourseListContainer: React.FC<Props> = ({
  currentPage,
  perView,
}) => {
  const auth_token = useAppSelector(getAuthToken);
  const { termData, getTermLoading } = useGetTerm(
    TermType.Courses,
    currentPage,
    perView,
    undefined,
    true
  );
  const { mutate, mutateLoading } = useUpdateTerm(TermType.Courses);

  //addCource
  const [name, setName] = useState<string>();

  const addTermSubmit = () => {
    if (auth_token && name) {
      mutate({
        auth_token: auth_token,
        name: name,
        tax: "courses",
      });
    }
    setName("");
  };

  const listItemSubmit = async (item_id: string, editName?: string) => {
    if (auth_token && item_id && editName) {
      mutate({
        auth_token: auth_token,
        name: editName,
        id: item_id,
        tax: "courses",
      });
    }
  };

  return (
    <ListWrapper pageTitle="コース一覧">
      <ListContentWrapper
        isLoading={getTermLoading || mutateLoading}
        displayCount={genDisplayCount(
          currentPage,
          termData.total_pages,
          perView,
          termData.total_entries
        )}
        totalPage={termData?.total_pages}
        totalEntries={termData?.total_entries}
        currentPage={currentPage}
        optionalComponent={
          <AddTerm
            title="コース"
            name_type="コース名"
            name={name}
            handleName={setName}
            handleSubmit={addTermSubmit}
          />
        }
      >
        <TermList
          terms={termData?.entries}
          noColor={true}
          name_type="コース名"
          handleName={setName}
          listItemSubmit={listItemSubmit}
        />
      </ListContentWrapper>
    </ListWrapper>
  );
};

export default CourseListContainer;
